const setTracker = params => {
  const { userId, trackerName, path, title } = params;
  window.ga(`${trackerName}.set`, { page: path, title, userId });
  window.ga(`${trackerName}.send`, 'pageview', path);
};

export default setTracker;
